import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/arrowDiagonalRight.tsx
var ArrowDiagonalRight = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M10.2322 19.4247L5.57535 19.4247C5.02306 19.4247 4.57535 18.977 4.57535 18.4247L4.57533 13.7678M19.4246 10.2323L19.4246 5.57544C19.4246 5.02316 18.9769 4.57544 18.4246 4.57544L13.7677 4.57543M18.7175 5.28256L5.28246 18.7176",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M10.2322 19.4247L5.57535 19.4247C5.02306 19.4247 4.57535 18.977 4.57535 18.4247L4.57533 13.7678M19.4246 10.2323L19.4246 5.57544C19.4246 5.02316 18.9769 4.57544 18.4246 4.57544L13.7677 4.57543M18.7175 5.28256L5.28246 18.7176",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
//#endregion
export { ArrowDiagonalRight };
